/**
 * AURA Panel CSS Styles
 */

export const PANEL_STYLES = `
  .aura-panel {
    position: fixed;
    top: 0;
    right: 0;
    width: var(--aura-panel-width);
    max-width: 100vw;
    height: 100vh;
    max-height: 100vh;
    background: var(--aura-bg);
    box-shadow: var(--aura-shadow-lg);
    z-index: var(--aura-z-panel);
    display: flex;
    flex-direction: column;
    transform: translateX(100%);
    transition: transform var(--aura-transition);
    overflow: hidden;
  }

  .aura-panel--open {
    transform: translateX(0);
  }

  .aura-panel--left {
    right: auto;
    left: 0;
    transform: translateX(-100%);
  }

  .aura-panel--left.aura-panel--open {
    transform: translateX(0);
  }

  .aura-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px var(--aura-spacing-lg);
    background: var(--aura-bg-secondary);
    color: var(--aura-text);
    border-bottom: 1px solid var(--aura-border);
  }

  .aura-panel__brand {
    display: flex;
    align-items: center;
    gap: var(--aura-spacing-sm);
  }

  .aura-panel__logo {
    width: 28px;
    height: 28px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .aura-panel__title {
    font-size: var(--aura-font-size-lg);
    font-weight: 600;
    margin: 0;
  }

  .aura-panel__header-right {
    display: flex;
    align-items: center;
    gap: var(--aura-spacing-sm);
  }

  .aura-panel__btn {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--aura-radius-sm);
    color: var(--aura-text-muted);
    transition: background-color var(--aura-transition-fast);
  }

  .aura-panel__btn:hover {
    background: var(--aura-bg-hover);
    color: var(--aura-text);
  }

  .aura-panel__btn svg {
    width: 16px;
    height: 16px;
  }

  .aura-panel__tabs {
    display: flex;
    border-bottom: 1px solid var(--aura-border);
    background: var(--aura-bg);
  }

  .aura-panel__tab {
    flex: 1;
    padding: 10px 8px;
    font-size: var(--aura-font-size-sm);
    font-weight: 500;
    color: var(--aura-text-muted);
    background: transparent;
    border-bottom: 2px solid transparent;
    transition: all var(--aura-transition-fast);
  }

  .aura-panel__tab:hover {
    color: var(--aura-text);
    background: var(--aura-bg-hover);
  }

  .aura-panel__tab--active {
    color: var(--aura-primary);
    border-bottom-color: var(--aura-primary);
  }

  .aura-panel__content {
    flex: 1;
    overflow-y: auto;
    padding: var(--aura-spacing-lg);
  }

  .aura-panel__section {
    margin-bottom: var(--aura-spacing-xl);
  }

  .aura-panel__section-title {
    font-size: var(--aura-font-size-md);
    font-weight: 600;
    color: var(--aura-text);
    margin-bottom: var(--aura-spacing-md);
    padding-bottom: var(--aura-spacing-xs);
    border-bottom: 1px solid var(--aura-border);
  }

  .aura-panel__subsection-title {
    font-size: var(--aura-font-size-md);
    font-weight: 600;
    color: var(--aura-text);
    margin: var(--aura-spacing-md) 0 var(--aura-spacing-sm);
  }

  .aura-panel__subsection-title:first-child {
    margin-top: 0;
  }

  .aura-panel__profiles {
    display: flex;
    flex-direction: column;
    gap: var(--aura-spacing-md);
  }

  .aura-panel__footer {
    padding: var(--aura-spacing-sm) var(--aura-spacing-lg);
    border-top: 1px solid var(--aura-border);
    background: var(--aura-bg-secondary);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--aura-spacing-xs);
  }

  .aura-panel__footer-link {
    font-size: var(--aura-font-size-sm);
    color: var(--aura-text-muted);
    text-decoration: none;
  }

  .aura-panel__footer-link:hover {
    color: var(--aura-primary);
    text-decoration: underline;
  }

  .aura-panel__footer-brand {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    color: var(--aura-text-muted);
    opacity: 0.7;
  }

  .aura-panel__footer-brand img {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }

  .aura-panel__footer-learn-more {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: var(--aura-secondary);
    text-decoration: none;
    font-weight: 500;
  }

  .aura-panel__footer-learn-more:hover {
    text-decoration: underline;
  }

  .aura-panel__footer-learn-more svg {
    width: 12px;
    height: 12px;
  }

  .aura-tab-panel {
    display: none;
  }

  .aura-tab-panel--active {
    display: block;
  }

  .aura-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: calc(var(--aura-z-panel) - 1);
    opacity: 0;
    pointer-events: none;
    transition: opacity var(--aura-transition);
  }

  .aura-overlay--visible {
    opacity: 1;
    pointer-events: auto;
  }

  @media (max-width: 480px) {
    .aura-panel {
      width: 100vw;
    }

    .aura-panel__btn {
      width: var(--aura-touch-target);
      height: var(--aura-touch-target);
    }

    .aura-panel__btn svg {
      width: 20px;
      height: 20px;
    }

    .aura-panel__tab {
      min-height: var(--aura-touch-target);
      padding: 10px 12px;
    }
  }

  /*
   * Touch devices go full-screen regardless of the reported CSS viewport
   * width.  shell.ts runs hardware touch-detection once at startup
   * (navigator.maxTouchPoints, userAgentData.mobile, ...) and tags the
   * shell host with data-aura-input="touch".  We key off that attribute
   * because @media (max-width: 480px) alone is unreliable: host pages that
   * force a wide/desktop viewport meta tag, or browsers in desktop-site
   * mode, make a phone report innerWidth well above 480 (observed 720-1667
   * on the user's Samsung S23 Ultra), so the media query never matches and
   * the panel is marooned at 400 px on the right.  The attribute reflects
   * the actual hardware and cannot be defeated by viewport/UA tricks.
   * Desktop ("fine") keeps the 400 px side-rail from the base rule.
   */
  :host([data-aura-input="touch"]) .aura-panel {
    width: 100vw;
    left: 0;
    right: 0;
    max-width: 100vw;
  }

  /*
   * Belt-and-suspenders for the panel width.  The JS attribute above can be
   * defeated on a phone in desktop-site mode or with an S Pen (navigator
   * reports as desktop → data-aura-input="fine"), leaving the panel marooned
   * at 400 px on the right.  The reading-mask drag handle is gated on this
   * exact media query and is confirmed working on the user's phone, which
   * PROVES (any-pointer: coarse) matches there even when JS detection does
   * not.  Keying the panel off the same signal guarantees the panel and the
   * handle can never disagree about whether the device is touch-capable.
   *
   * (any-pointer: coarse) — NOT (pointer: coarse) — is deliberate: an S Pen
   * reports the PRIMARY pointer as fine, but the phone's touchscreen still
   * counts as a coarse ANY-pointer, so any-pointer is the signal that holds
   * on stylus phones.
   */
  @media (any-pointer: coarse) {
    .aura-panel {
      width: 100vw;
      left: 0;
      right: 0;
      max-width: 100vw;
    }
  }
`;
